import React, { useEffect, useRef, useState } from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { Collection } from "./components/Collection";
import { BeforeAfter } from "./components/BeforeAfter";
import { Situations } from "./components/Situations";
import { Volumes } from "./components/Volumes";
import { Tools } from "./components/Tools";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { Author } from "./components/Author";
import { Faq } from "./components/Faq";
import { FinalCta } from "./components/FinalCta";
import { Footer } from "./components/Footer";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  const heroCtaRef = useRef<HTMLDivElement>(null);
  const [showFloating, setShowFloating] = useState(false);
  useEffect(() => {
    const check = () => {
      const el = heroCtaRef.current;
      if (!el) return;
      setShowFloating(el.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-sans text-white" data-id="element-0" data-mp="2znfy0adui2o6">
      <MetaPixel data-id="element-1" data-mp="33orkw85c49so" />
      <Hero ref={heroCtaRef} data-id="element-2" data-mp="38lrs4mdx7ild" />
      <main data-id="element-3" data-mp="38kqd66tsabyd">
        <Collection data-id="element-4" data-mp="38l06o4e1f18t" />
        <BeforeAfter data-id="element-5" data-mp="38kgnylgkc8tq" />
        <Situations data-id="element-6" data-mp="3dkuu1xylt8p4" />
        <Volumes data-id="element-7" data-mp="3dle46si0issl" />
        <Tools data-id="element-8" data-mp="3dlw4q1bpjt6b" />
        <Bonuses data-id="element-9" data-mp="3dmfolnkx4rmz" />
        <Offer data-id="element-10" data-mp="3dirwmsv4gdad" />
        <Guarantee data-id="element-11" data-mp="nvj53kddcmru" />
        <Testimonials data-id="element-12" data-mp="nw2ci75e7srm" />
        <Author data-id="element-13" data-mp="nuhjilyq8hvv" />
        <Faq data-id="element-14" data-mp="nv1284w7baay" />
        <FinalCta data-id="element-15" data-mp="nxn4bp0boxls" />
      </main>
      <Footer data-id="element-16" data-mp="sudlygrs019b" />
      <FloatingCta visible={showFloating} data-id="element-17" data-mp="stuclog6yl6w" />
      <PurchasePopup data-id="element-18" data-mp="ssstcwp0use3" />
    </div>;
}